import type { WregStep } from '../wregSteps';
import type { WregExceptionTone } from './WregException';

type WregExceptionStep = Extract<WregStep, `x-${string}`>;

type WregExceptionCopy = {
  titleKey: string;
  bodyKey: string;
  primaryKey: string;
  tone?: WregExceptionTone;
};

const WREG_EXCEPTIONS: Record<WregExceptionStep, WregExceptionCopy> = {
  'x-notelig': {
    titleKey: 'wreg.x.notelig.title',
    bodyKey: 'wreg.x.notelig.clinical',
    primaryKey: 'wreg.x.support',
  },
  'x-already': {
    titleKey: 'wreg.x.already.title',
    bodyKey: 'wreg.x.already.body',
    primaryKey: 'wreg.x.support',
  },
  'x-control': {
    titleKey: 'wreg.x.control.title',
    bodyKey: 'wreg.x.control.body',
    primaryKey: 'wreg.x.support',
    tone: 'warm',
  },
  'x-mismatch': {
    titleKey: 'wreg.x.mismatch.title',
    bodyKey: 'wreg.x.mismatch.body',
    primaryKey: 'wreg.x.mismatch.cta',
  },
  'x-noqualify': {
    titleKey: 'wreg.x.noqualify.title',
    bodyKey: 'wreg.x.noqualify.body',
    primaryKey: 'wreg.x.support',
  },
  'x-error': {
    titleKey: 'wreg.x.error.title',
    bodyKey: 'wreg.x.error.body',
    primaryKey: 'wreg.x.error.support',
  },
  'x-switchok': {
    titleKey: 'wreg.x.switchok.title',
    bodyKey: 'wreg.x.switchok.body',
    primaryKey: 'wreg.x.switchok.cta',
    tone: 'ok',
  },
  'x-outreach': {
    titleKey: 'wreg.x.outreach.title',
    bodyKey: 'wreg.x.outreach.body',
    primaryKey: 'wreg.x.support',
    tone: 'ok',
  },
  'x-labspending': {
    titleKey: 'wreg.x.labspending.title',
    bodyKey: 'wreg.x.labspending.body',
    primaryKey: 'wreg.x.ack',
    tone: 'ok',
  },
  'x-declined': {
    titleKey: 'wreg.x.declined.title',
    bodyKey: 'wreg.x.declined.body',
    primaryKey: 'wreg.x.restart',
  },
};

const isWregExceptionStep = (step: WregStep): step is WregExceptionStep => step.startsWith('x-');

export { WREG_EXCEPTIONS, isWregExceptionStep };
export type { WregExceptionCopy, WregExceptionStep };
